import * as React         from 'react'
import classnames         from 'classnames'
import {
  Props,
}                         from './types'
import ToggleSwitchField  from '../Fields/ToggleSwitch'

import './styles.scss'

export class ToggleSwitch extends React.Component<Props> {
  constructor(props: Props) {
    super(props)

    this.handleToggle = this.handleToggle.bind(this)
  }

  handleToggle(value: boolean) {
    this.props.onClick(value)
  }

  render() {
    const {
      label,
      default: defaultValue,
      disabled,
    } = this.props

    return (
      <section className="toggleSwitch">
        <div
          className={classnames('toggleSwitch__label', disabled && 'toggleSwitch__label__disabled')}
        >
          {label}
        </div>
        <div className="toggleSwitch__element">
          <ToggleSwitchField
            default={defaultValue}
            onHandleClick={this.handleToggle}
            disabled={disabled}
          />
        </div>
      </section>
    )
  }
}